export default {
  state: {
    shops: null,
    currentShop: null,
    shopsAZ: null,
  },
  mutations: {
    setShops(state, payload) {
      state.shops = payload;
    },
    setCurrentShop(state, payload) {
      state.currentShop = payload;
    },
    setShopsAZ(state, payload) {
      state.shopsAZ = payload;
    },
  },
  actions: {
    loadShops: ({
      commit
    }, payload) => {
      //  if(typeof  payload === 'object'){
      commit("setShops", payload);
      /*  }
       else{
         commit("setShops", {});
       } */
    },
    setCurrentShop: ({
      commit
    }, payload) => {
      commit("setCurrentShop", payload);
    },
    setShopsAZ: ({
      commit
    }, payload) => {
      commit("setShopsAZ", payload);
    },
  },
  getters: {
    getShops(state) {
      return state.shops
    },
    getCurrentShop(state) {
      return state.currentShop
    },
    getShopsAZ(state) {
      return state.shopsAZ
    },
  }
}
